import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
  AfterViewInit
} from '@angular/core';
import { APIService } from '../../../../api/api.service';
import { NotifierService } from '../../../../_services/notifier.service';
import { regions } from '../../../../dash/dash.component';

declare let $: any;
declare let flatpickr: any;

@Component({
  selector: 'onboarded-edit',
  templateUrl: './onboardededit.component.html',
  styleUrls: ['./onboardededit.component.css'],
})
export class onboardingEditUpdateComponent implements OnInit, OnDestroy, AfterViewInit {
  additionalContacts: string[] = [''];
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  regions: any = regions;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  regionId: any;
  dateRange: any;
  currentMessage: any;
  @Output() hideModel = new EventEmitter<any>();
  @Input() ri: any;
  @Input('action') action: any;
  dbInstanceTypes: any = [];
  dbEngines: any = [];
  tempBucketInputs: any;
  tempBucketInputsBackup: any;
  selectedRegion: any;
  selectedBucket: any;
  originalInputsLength: any;
  childAccounts:any;

  constructor(
    private apiService: APIService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.ri = { ...this.ri };
    $('#regionsList').selectpicker();
    $('#childAccounts').selectpicker();
    
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });

    // setTimeout(() => {
    //   $('.selectpicker').selectpicker();
    //   $('.selectpicker').selectpicker('refresh');
    // }, 300);
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });

    setTimeout(() => {
      $('#regionsList').selectpicker('refresh');
      $('#childAccounts').selectpicker('refresh');
    }, 1000);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
  }

res:any;
  async load() {
    this.notifier.loading(true);
    let data: any = {
      action: 'fetchAccountData',
      mid: this.ri.accountId,
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL =
      'https://dev.api.swayam.cloud/v3/admin/billing/fetchenabledmasteraccounts';

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      // this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.res = result.masterList;

      if (this.res.multiBucket && this.res.multiBucketList?.length) {
        this.multiBucketChange(true);
        this.tempBucketInputs = this.mapListToInputs(this.res.multiBucketList);
        this.tempBucketInputs = this.res.multiBucketList.map((item:any) => {
          const bucketName = Object.keys(item)[0]; // Get the bucket name
          const folderRegion = item[bucketName]; // Get the folder and region string
          const childs = item.childs;
          const [folderName, region] = folderRegion.split(',');
        
          return { bucket: bucketName, folder: folderName, region: region, childs: childs };
        });
        // Set default region for the first item in the list (if applicable)
        this.selectedRegion = this.tempBucketInputs[0]?.region;
        this.selectedBucket = this.tempBucketInputs[0]?.bucket;
      } else if (this.res.multiBucket) {
        // Show one empty set if user enabled multi-bucket but has no existing values
        this.tempBucketInputs = [{ bucket: '', folder: '', region: '', childs: [], isExisting: false }];
      }
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }

    if (this.res.multiBucket && this.res.multiBucketList?.length) {
      this.tempBucketInputs = this.mapListToInputs(this.res.multiBucketList);
      this.originalInputsLength = this.tempBucketInputs.length;
    } else if (this.res.multiBucket) {
      this.tempBucketInputs = [{ bucket: '', folder: '', region: '', childs:[] }];
      this.originalInputsLength = 0;
    }

    await this.getaccounts()
    this.notifier.loading(false);
  }

  

  async getaccounts(){
    this.notifier.loading(true);

    let data = {
      a: "mids"
  }

  let header = {
    Authorization: localStorage.getItem('t'),
  };
  let apiURL =
    'https://dev.api.swayam.cloud/v3/admin/billing/lid-mid';

  let result = await this.apiService.postDataPromis(apiURL, data, header);

  if (result.status == '1' || result.s == '1') {
    const clientIds = result.mids.find((item:any) => item.id === this.ri.accountId)?.clientId || [];
    await this.loadchildaccounts(clientIds[0])
    }
  
  else{
    this.notifier.alert('Info', '', result.msg, 'info', 5000);
  }

    this.notifier.loading(false);
}


async loadchildaccounts(clientId:any){
  this.notifier.loading(true);

  let data = {
    a: "lid",
    clientId: [
        clientId
    ]
}

let header = {
  Authorization: localStorage.getItem('t'),
};
let apiURL =
  'https://dev.api.swayam.cloud/v3/admin/billing/lid-mid';

let result = await this.apiService.postDataPromis(apiURL, data, header);
if (result.status == '1' || result.s == '1') {
  this.childAccounts = result.lids;

  if (this.ri?.tempBucketInputs?.length) {
    this.ri.tempBucketInputs.forEach((item: any) => {
      item.childs = result.lids.map((lid: any) => lid.id); // Patch with all child IDs
    });
  }

  // Refresh the selectpicker
  setTimeout(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 0);
} else {
  this.notifier.alert('Info', '', result.msg, 'info', 5000);
}


  this.notifier.loading(false);
}



  // async fetchRICost() {
  //   let instanceType: string = $('#instanceTypes').val();
  //   let engines: string = $('#engines').val();
  //   let region: string = $('#regionsList').val();
  //   let bt: string = $('#billingTypes').val();
  //   let deploymentType: String = $('#deploymentType').val();
  //   if (
  //     this.ri.riType == 'OnDemand' ||
  //     !engines ||
  //     !instanceType ||
  //     !deploymentType ||
  //     !region ||
  //     !bt
  //   ) {
  //     return;
  //   }
  //   this.notifier.loading(true);
  //   let data = {
  //     accountId: this.accountId,
  //     action: 'fetchRdsRiPrice',
  //     dbInstanceType: instanceType,
  //     dbEngine: engines,
  //     deploymentType: deploymentType,
  //     region: region,
  //     riType: bt,
  //   };
  //   let header = {
  //     Authorization: localStorage.getItem('t'),
  //   };

  //   let apiURL =
  //     'https://api.swayam.cloud/prod/msopsusers/billing/fetchrdsripurchaseorder';
  //   let result = await this.apiService.postDataPromis(apiURL, data, header);
  //   if (result.status == '1' || result.s == '1') {
  //     this.ri.riCost = result.onDemandCost;
  //   } else {
  //     this.notifier.alert('Info', '', result.msg, 'info', 5000);
  //   }
  //   this.notifier.loading(false);
  // }

  // async fetchInstanceTypes() {
  //   this.notifier.loading(true);
  //   let data = { action: 'fetchdbtypes' };

  //   let header = {
  //     Authorization: localStorage.getItem('t'),
  //   };
  //   //https://api.swayam.cloud/v3/admin/support
  //   let apiURL =
  //     'https://api.swayam.cloud/prod/msopsusers/billing/fetchrdsripurchaseorder';

  //   let result = await this.apiService.postDataPromis(apiURL, data, header);

  //   if (result.status == '1' || result.s == '1') {
  //     this.dbInstanceTypes = result.dbInstancetypes;
  //     this.dbEngines = result.dbEngineTypes;
  //     if (this.action.trim() == 'save') {
  //       if (!this.ri.dbInstanceType) {
  //         this.ri.dbInstanceType = 'NA';
  //       }
  //       if (!this.ri.dbEngine) {
  //         this.dbEngines[0];
  //       }
  //     }
  //     setTimeout(() => {
  //       $('#instanceTypes').selectpicker('refresh');
  //       $('#engines').selectpicker('refresh');
  //     }, 100);
  //   } else {
  //     this.notifier.alert('Info', '', result.error, 'info', 5000);
  //   }
  //   this.notifier.loading(false);
  // }
  onPolicyChange(policy: boolean) {
    if (policy === false) {
      // Store the current values before clearing them
      this.tempBucketName = this.ri.billingConductorBucketName;
      this.tempFolderName = this.ri.billingConductorFolderName;

      // Clear the values
      this.ri.billingConductorBucketName = '';
      this.ri.billingConductorFolderName = '';
    } else if (policy === true) {
      // Restore the earlier values when toggling back to "Yes"
      this.ri.billingConductorBucketName = this.tempBucketName;
      this.ri.billingConductorFolderName = this.tempFolderName;
    }

    // Update the policy status
    this.ri.billingConductorEnabled = policy;    
  }
  tempBucketName: any;
  tempFolderName: any;

  prepareBucketListForAPI(): any[] {
    return this.tempBucketInputs
      .filter((item: any) => item.bucket && item.folder && item.region && item.childs?.length)
      .map((item: any) => ({
        [item.bucket]: `${item.folder},${item.region}`,
        childs: item.childs
      }));
  }
  

  async deleteBucketInput(index: number) {
    this.notifier.loading(true);
    const item = this.tempBucketInputs[index];
    if (index < this.originalInputsLength) {
      // Existing record, call API
      const data: any = {
        action: 'deleteMultiBucketRecord',
        mid: this.res.accountId,
        bucketName: item.bucket
      };
  
      let header = {
        Authorization: localStorage.getItem('t'),
      };
      let apiURL =
        'https://dev.api.swayam.cloud/v3/admin/billing/fetchenabledmasteraccounts';
  
      let result = await this.apiService.postDataPromis(apiURL, data, header);
  
      if (result.status == '1' || result.s == '1') {
        this.notifier.alert('Success', '', result.msg, 'success', 5000);
        this.tempBucketInputs.splice(index, 1); // Remove after successful API call
        this.originalInputsLength--; // Adjust original length
      } else {
        this.notifier.alert('Info', '', result.msg, 'info', 5000);
      }
      } else {
      // New entry, just remove without calling API
      this.tempBucketInputs.splice(index, 1);
    }
    this.notifier.loading(false);

  }
  
  async updateEntry() {
    if (this.res.billingConductorEnabled) {
      if (this.res.billingConductorBucketName == undefined || this.res.billingConductorBucketName == '') {
        this.notifier.alert('Error', '', 'Bucket Name is must.', 'error', 5000);

        return
      }
      else if (this.res.billingConductorFolderName == undefined || this.res.billingConductorFolderName == ''){
        this.notifier.alert('Error', '', 'Folder Name is must.', 'error', 5000);

        return
      }
    }
    this.notifier.loading(true);
    let data: any = {
      action: 'updateConductorDetails',
      mid: this.res.accountId,
      billingConductorEnabled: this.res.billingConductorEnabled,
      billingConductorBucketName: this.res.billingConductorBucketName,
      billingConductorFolderName: this.res.billingConductorFolderName,
      billingInSwayam:this.res.billingInSwayam,
      visibilityInSwayam: this.res.visibilityInSwayam,
      bucketName: this.res.bucketName,
      folderName: this.res.folderName,
      multiBucket: this.res.multiBucket,
      multiBucketList: this.prepareBucketListForAPI()
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL =
      'https://dev.api.swayam.cloud/v3/admin/billing/fetchenabledmasteraccounts';

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.close(true);
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }


    this.notifier.loading(false);
  }
  

// Method to handle multi-bucket change logic
multiBucketChange(value: boolean) {
  this.res.multiBucket = value;

  if (!value) {
    this.res.multiBucketList = this.mapInputsToList(this.tempBucketInputs);
    this.tempBucketInputs = [];
  } else {
    if (this.res.multiBucketList.length) {
      this.tempBucketInputs = this.mapListToInputs(this.res.multiBucketList);
      this.originalInputsLength = this.tempBucketInputs.length;
    } else {
      this.tempBucketInputs = [{ bucket: '', folder: '', region: '', childs: [] }];
      this.originalInputsLength = 0;
    }
  }
  setTimeout(() => {
    $('.selectpicker').selectpicker('refresh');
    $('#childAccounts').selectpicker('refresh');
  });
}

// Method to convert inputs to list format
mapListToInputs(list: any[]): any[] {
  const inputs: any[] = [];
  for (let obj of list) {
    const bucketName = Object.keys(obj)[0];
    const value = obj[bucketName];
    const [folder, region] = value.split(',');
    const childs = obj.childs;
    inputs.push({
      bucket: bucketName,
      folder: folder?.trim() || '',
      region: region?.trim() || '',
      childs: childs,
      isExisting: true
    });
  }
  return inputs;
}

// Method to map inputs back to list format for backend
mapInputsToList(inputs: any[]): any[] {
  return inputs.map(item => ({
    [item.bucket]: `${item.folder},${item.region}`,
    childs: item.childs
  }));
  
}


  addBucketInput() {
    this.tempBucketInputs.push({ bucket: '', folder: '', region: '', childs: [] });
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }

  isRegionUnmatched(regionId: string): boolean {
    return regionId && !this.regions.some((r: any) => r.id === regionId);
  }
  
  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }

  close(dataAction: any = false) {
    if (dataAction) {
      this.hideModel.emit(dataAction);
    } else {
      this.hideModel.emit(false);
    }
  }
}
